import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () =>
    (await import('./DocumentTemplatesSettings')).DocumentTemplatesSettings,
  'documentTemplatesSettings',
);
